/* eslint-disable no-nested-ternary */
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {MinipurchaseResponseBody, UpdateMinipurchaseRequestBody} from '@dms/api/finance';
import {castTimeToDateISOString} from '@dms/features/tasks';

import {ExternalFilter} from '../types/ExternalFilter';
import {transformExternalFilterToMinipurchaseSpecification} from './transformExternalFilterToMinipurchaseSpecification';

export function buildMinipurchaseUpdateBody(
  baseMiniPurchase: MinipurchaseResponseBody,
  values: ExternalFilter,
  tenantCurrency: string
): UpdateMinipurchaseRequestBody {
  return {
    ...baseMiniPurchase,
    minipurchaseId: baseMiniPurchase.id,
    filteredSpecifications:
      'type' in values
        ? transformExternalFilterToMinipurchaseSpecification(values)
        : baseMiniPurchase.filteredSpecifications,
    additionalInformation:
      'additionalInformation' in values
        ? (values.additionalInformation ?? null)
        : baseMiniPurchase.additionalInformation,
    testDriveRequested:
      'testDriveRequested' in values
        ? values.testDriveRequested?.[0] === 'yes'
        : baseMiniPurchase.testDriveRequested,
    testDriveScheduledAt:
      'testDriveScheduledAtDate' in values
        ? values.testDriveScheduledAtDate && values.testDriveScheduledAtTime
          ? castTimeToDateISOString(
              values.testDriveScheduledAtDate,
              values.testDriveScheduledAtTime
            )
          : null
        : baseMiniPurchase.testDriveScheduledAt,
    testDriveNote:
      'testDriveNote' in values ? values.testDriveNote : baseMiniPurchase.testDriveNote,
    preferredDownPayment:
      'preferredDownPayment' in values
        ? isNotNilOrEmpty(values.preferredDownPayment)
          ? {amount: String(values.preferredDownPayment), currency: tenantCurrency}
          : null
        : baseMiniPurchase.preferredDownPayment,
    paymentPreferenceCodeId:
      'paymentPreferenceCodeId' in values
        ? (values.paymentPreferenceCodeId?.[0] ?? null)
        : baseMiniPurchase.paymentPreferenceCodeId,
  };
}
